import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApplicationService, Customizations } from './api.services';

@Injectable({
  providedIn: 'root'
})
export class CustomizationService {
  private cachedCustomizations: BehaviorSubject<Customizations> = new BehaviorSubject(CustomizationService.Default());
  public get customizations$(): Observable<Customizations> {
    return this.cachedCustomizations.asObservable();
  };
  constructor(applicationService: ApplicationService) {

    applicationService.customizations().toPromise().then(c => { this.cachedCustomizations.next(c); });
  }

  public static Default(): Customizations {
    return {
      name: 'Schoolinlog Sync',
      productLink: 'https://www.schoolinlog.nl/',
      logo: '/assets/schoolinlog.svg'
    }
  }
}
